import {z} from 'zod';
import {CalculateTransferFeeResult} from './calculate-transfer-fee-result';

export const EarlyTerminationResult = CalculateTransferFeeResult.extend({
  pdfDocumentId: z.string(),
});

export type EarlyTerminationResult = z.infer<typeof EarlyTerminationResult>;
